import { RiQuestionnaireLine } from "react-icons/ri";
import { Button, Tooltip } from "antd";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const OnboardButton = () => {
  // -------------------------- VAR -----------------------------
  const [_, setSearchParams] = useSearchParams();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Hướng dẫn sử dụng cho người mới">
      <RiQuestionnaireLine
        onClick={() => setSearchParams({ viewOnboard: true })}
        className="cursor-pointer rounded-full text-[24px] text-gray-400"
      />
    </Tooltip>
  );
};
export default OnboardButton;
